import { useContext } from "react";
import { Box, Button } from "@mui/material";
import { Sync as SyncIcon } from "@mui/icons-material";
import { SalesProductReport, CreateFeatureLogs } from "../../../global/API";
import { DataSetArray } from "./DataSetArray";
import Excel from "../../../../../assets/images/icons/excel.png";
import ReactExport from "react-data-export";
import moment from "moment/moment";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { FeatureIdState } from "../../../toolUsage/global/GlobalFcn";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export const Generate = () => {
    const { tool_state, report_state, global_component_state } = useContext(ToolContext);
    const { __SESSION } = tool_state;
    const { form, comProductIds, generateForm, salesProductData, salesProductList } = report_state;
    const { snackBarLoader } = global_component_state;
    const tool_id = process.env.REACT_APP_TID_BIZ;

    const SendFeatureLogs = async () => {
        const body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState("reports")}->2`,
            feature_id: 1,
            feature_name: "branch-product-sales-report",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2,
        };
        await CreateFeatureLogs(body);
    };

    const FinalData = (rows) => {
        salesProductData.set(rows);
        salesProductList.set(rows);
        generateForm.set((prev) => ({ ...prev, infiniteLoad: false, offset: 0 }));
    };

    const handleGenerate = async () => {
        if (
            form.data.to === "" ||
            form.data.from === "" ||
            form.data.to < form.data.from
        ) {
            snackBarLoader.set({
                ...snackBarLoader.data,
                snackbar: true,
                msg: "Invalid Date!",
                type: "error",
            });
            return;
        }

        generateForm.set((prev) => ({
            ...prev,
            infiniteLoad: true,
            offset: 0,
        }));

        salesProductData.set([]);
        salesProductList.set([]);

        try {
            const limit = generateForm.data.limit;
            let offset = 0;
            let allRows = [];
            let shouldContinue = true;

            while (shouldContinue) {
                const qsp = {
                    branch_id: form.data.branch_id,
                    company_id: __SESSION.data.uaccess[0].company_id,
                    product_id:
                        form.data.product_id > 0
                            ? form.data.branch_id === 0
                                ? JSON.stringify(comProductIds)
                                : JSON.stringify([form.data.product_id])
                            : form.data.product_id,
                    from: form.data.from,
                    to: form.data.to,
                    limit,
                    offset,
                };

                let res = await SalesProductReport(qsp);

                if (!res || !Array.isArray(res)) {
                    shouldContinue = false;
                    break;
                }

                res = res.filter((item) => parseInt(item.visible) === 1);

                if (res.length === 0) {
                    shouldContinue = false;
                    break;
                }

                allRows = [...allRows, ...res];
                offset += res.length;

                generateForm.set((prev) => ({
                    ...prev,
                    offset,
                }));

                if (res.length < limit) {
                    shouldContinue = false;
                }
            }

            FinalData(allRows);
            await SendFeatureLogs();
        } catch (error) {
            console.error(error);
            generateForm.set((prev) => ({ ...prev, infiniteLoad: false, offset: 0 }));
            snackBarLoader.set({
                ...snackBarLoader.data,
                snackbar: true,
                msg: "Failed to generate report.",
                type: "error",
            });
        }
    };

    return (
        <Box minHeight="55px" display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
            {salesProductList.data.length > 0 && (
                <ExcelFile
                    filename={`Sales_Product_Reports_${moment(new Date()).format("MM-DD-YYYY")}`}
                    element={
                        <Box
                            display="flex"
                            alignItems="center"
                            className="c-pointer"
                            bgcolor="#d5ffe6ff"
                            borderRadius={2}
                            padding="12px 16px"
                            minWidth="200px"
                        >
                            <img src={Excel} alt="excel-img" />
                            <Box ml="10px" color="#1D6F42">
                                Export in excel
                            </Box>
                        </Box>
                    }
                >
                    <ExcelSheet dataSet={DataSetArray(salesProductList.data)} name="Reports" />
                </ExcelFile>
            )}

            <Box
                id="walkthrough-branch-product-report-step-5"
                onClick={handleGenerate}
                component={Button}
                disableFocusRipple={true}
                minHeight="50px"
                minWidth="130px"
                borderRadius={3}
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="primary.main"
                color="#fff"
                sx={{ border: "2px solid #EBEBEB", ":hover": { bgcolor: "primary.main", color: "#FFFFFF" } }}
                startIcon={<SyncIcon />}
            >
                <Box fontSize={16} fontWeight={400} lineHeight="19px">
                    Generate
                </Box>
            </Box>
        </Box>
    );
};